<script>
    /**
     * @NOTE The parent of this component must have the css property `position: relative;`
    */
</script>

<span class="badge m-cart__indicator"><slot /></span>



<style>
    .m-cart__indicator:global(.zoom-in) {
        top: 5px;
        left: 50% !important;
        right: initial !important;
        width: calc(var(--space)*2) !important;
        height: var(--space);
        display: block;
        animation: none;
    }

    .m-cart__indicator:global(.zoom-out) {
        top: 5px;
        left: 50% !important;
        right: initial !important;
        width: calc(var(--space)*2) !important;
        height: var(--space);
        display: block;
        animation: none;
    }

    .badge {
        position: absolute;
        background: var(--darkgray);
        width: calc(var(--space)*2);
        height: var(--space);
        line-height: var(--space);
        top: 5px;
        left: 50%;
        margin-left: calc(var(--space)*.75);
        font-size: calc(var(--space)*.75);
        color: var(--color-text-invert);
        font-family: var(--font-heading);
        font-weight: 900;
        padding: 0 2px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-align: center;
        border-radius: 0;
    }
</style>